import { render, staticRenderFns } from "./translateAll.vue?vue&type=template&id=938e62e2&scoped=true&"
import script from "./translateAll.vue?vue&type=script&lang=js&"
export * from "./translateAll.vue?vue&type=script&lang=js&"
import style0 from "./translateAll.vue?vue&type=style&index=0&id=938e62e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938e62e2",
  null
  
)

export default component.exports